const config = {
    env:'uat',
    apiURL: window._env_.API_URL,
    documentURL: window._env_.DOCVAULT_URL,
    electronicFee:window._env_.ELECTRONICFEE,
    vat: window._env_.VAT,
    serviceFee: window._env_.SERVICEFEE,
    docUploadCount: window._env_.DOCUPLOADCOUNT,
    flyerNotificationUserId: window._env_.FLYERNOTIFICATIONUSERID,
    enableEditInAdditionalPaymentForSubadmin: window._env_.ENABLE_EDIT_IN_ADDITIONALPAYMENT_FOR_SUBADMIN,
    refundRequestMessage: window._env_.REFUNDREQUESTMESSAGE,
    systemUserId: window._env_.SYSTEMUSERID
};

const CONFIG = config;

export default CONFIG;